import { Injectable } from '@angular/core';
import { BaseService } from '../../shared/service/base.service';

@Injectable({
  providedIn: 'root'
})
export class MfaService {
  private baseUrl = 'api/v1/mfa';

  constructor(private _base: BaseService) {}

  private withUserId(endpoint: string, userId?: number | null): string {
    return userId ? `${endpoint}?userId=${userId}` : endpoint;
  }

  /**
   * Get MFA status for current user
   */
  getStatus(userId?: number | null) {
    return this._base.get(this.withUserId(`${this.baseUrl}/status`, userId));
  }

  /**
   * Generate secret and QR code for MFA setup
   */
  setup(userId?: number | null) {
    return this._base.post({}, this.withUserId(`${this.baseUrl}/setup`, userId));
  }

  /**
   * Verify TOTP code and enable MFA
   */
  verifySetup(secret: string, code: string, userId?: number | null) {
    return this._base.post({ secret, code }, this.withUserId(`${this.baseUrl}/verify-setup`, userId));
  }

  /**
   * Disable MFA with verification code
   */
  disable(code?: string, userId?: number | null) {
    return this._base.post({ code }, this.withUserId(`${this.baseUrl}/disable`, userId));
  }

  reset(userId: number) {
    return this._base.post({}, `${this.baseUrl}/reset?userId=${userId}`);
  }

  /**
   * Verify MFA code during login (public endpoint)
   */
  verifyLogin(mfaToken: string, code: string) {
    return this._base.post({ mfaToken, code }, 'api/v1/auth/portal/mfa-verify');
  }
}
